import { render, staticRenderFns } from "./DeputyModal.vue?vue&type=template&id=6771ad4b"
import script from "./DeputyModal.vue?vue&type=script&lang=js"
export * from "./DeputyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports